import {  useLayoutEffect } from 'react';
import TextInformation from '../../components/TextInformation/TextInformation';
import {
  SmallHeightDivider,
  MediumHeightDivider,
  StyledButtonOutlined,
} from '../../theme/Styles';
import { useDispatch } from 'react-redux';
import { UpdateAppSubHeaderTitle } from '../../redux/actions/UiActions';
import {
  ButtonContainer,
  ContactInfoContainer,
  Container,
  MapContainer,
} from './styles/ContactStyles';
import { useFormik } from 'formik';
import { FormSchema } from './ContactConstants';
import { Grid } from '@mui/material';
import TextField from '../../components/TextField/TextField';
import Swal from 'sweetalert2';
import { useQuery } from 'react-query';
import { getContactDataFromWordpress } from '../../api/Contact';
import { useTranslation } from 'react-i18next';
import PhoneTextField from '../../components/PhoneTextField/PhoneTextField';
import CenterLoading from '../../components/CenterLoading/CenterLoading';

function Contact() {
  const dispatch = useDispatch();
  const { data, isLoading } = useQuery(['contactData'], () =>
    getContactDataFromWordpress()
  );

  const [t, i18n] = useTranslation('Contact');

  const formik = useFormik({
    initialValues: {
      fullName: '',
      email: '',
      phoneNumber: '',
      message: '',
    },
    validationSchema: FormSchema,
    validateOnChange: true,
    validateOnBlur: true,

    onSubmit: (values) => {

      Swal.fire({
        title: `Mensaje enviado `,
        text: 'Gracias por ponerse en contacto con nosotros   ',
        icon: 'success',
        timer: 5000,
        timerProgressBar: true,
      });
    },
  });

  useLayoutEffect(() => {
    //UPDATE APP HEADER SUBTITLE
    dispatch(UpdateAppSubHeaderTitle(t('Contact'))); // TITLE OF SUBHEADER APP
  }, [i18n.language]);
  /*
  useEffect(() => {
    getAndSetAllWordPressContent();

  }, []);
*/

  if (isLoading) return <CenterLoading />;
  return (
    <Container>
      <TextInformation title={t('Contact_information')} />
      <SmallHeightDivider />

      <Grid
        alignItems='center'
        justifyContent='space-between'
        container
        direction='row'
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 8, sm: 8, md: 12 }}
      >
        {data &&
          data.map((content) => (
            <Grid item xs={12} sm={12} md={6}>
              <ContactInfoContainer>
                <label>
                  <strong>{content.title}</strong>
                </label>
                <p style={{ marginTop: '0.5%' }}>
                  {content.address}
                  <br />
                  {content.phoneNumber}
                  <br />
                  {content.email}
                  <br />
                  {content.website}
                </p>
              </ContactInfoContainer>
            </Grid>
          ))}
      </Grid>

      <TextInformation title={t('contactWithUs')} />
      <SmallHeightDivider />

      <Grid
        alignItems='center'
        justifyContent='center'
        container
        direction='row'
        spacing={{ xs: 2, md: 3 }}
        columns={{ xs: 8, sm: 8, md: 12 }}
      >
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            title={t('Full_name')}
            type='text'
            id='fullName'
            required
            value={formik.values.fullName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.fullName && Boolean(formik.errors.fullName)}
            helperText={formik.touched.fullName && formik.errors.fullName}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={6}>
          <TextField
            title={t('Email')}
            type='email'
            id='email'
            required
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.email && Boolean(formik.errors.email)}
            helperText={formik.touched.email && formik.errors.email}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={6}>
          <PhoneTextField
            title={t('Telephone_contact')}
            type='text'
            id='phoneNumber'
            value={formik.values.phoneNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)
            }
            helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
            required
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <TextField
            title={t('Message')}
            type='text'
            id='message'
            multiline
            value={formik.values.message}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.message && Boolean(formik.errors.message)}
            helperText={formik.touched.message && formik.errors.message}
            required
          />
        </Grid>
      </Grid>
      <SmallHeightDivider />

      <ButtonContainer>
        <StyledButtonOutlined onClick={formik.handleSubmit} variant='outlined'>
          {t('SEND_MESSAGE')}
        </StyledButtonOutlined>
      </ButtonContainer>
      <MediumHeightDivider />
      <MapContainer>
        <iframe
          src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3784.714058612757!2d-69.97550868579688!3d18.451287576106736!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8ea561ebff768b75%3A0xa76a69f95f4a6da5!2sCentro%20de%20Exportaci%C3%B3n%20e%20Inversi%C3%B3n%20de%20la%20Rep%C3%BAblica%20Dominicana!5e0!3m2!1sen!2sdo!4v1639411345081!5m2!1sen!2sdo'
          width='100%'
          height='100%'
          style={{ border: 0 }}
          allowfullscreen=''
          loading='lazy'
        />
      </MapContainer>
    </Container>
  );
}

export default Contact;
